import ContentLoader from 'react-content-loader'

const backgroundColor = "#353530"
const foregroundColor = "#666660"


// const backgroundColor = "#3a3323"
// const foregroundColor = "#353532"


export const BoxLoader = (props) => (
    <ContentLoader width={'100%'} height={"100%"} backgroundColor={backgroundColor} foregroundColor={foregroundColor} {...props}>
        <rect x="0" y="0" width="100%" height="100%" />
    </ContentLoader>
)

export const FeedLoader = (props) => (
    <ContentLoader height={160} width={'100%'} backgroundColor={backgroundColor} foregroundColor={foregroundColor} {...props}>
        <circle cx="30" cy="30" r="30" />
        <rect x="90" y="16" rx="5" ry="5" width="321" height="15" />
        <rect x="70" y="39" rx="5" ry="5" width="220" height="9" />
        <rect x="0" y="70" rx="10" ry="10" width="100%" height="80" />
    </ContentLoader>
)


export const CommentLoaders = props => (
    <ContentLoader height={100} width={'100%'} backgroundColor={foregroundColor} foregroundColor={backgroundColor} {...props}>
        <circle cx="20" cy="20" r="20" />
        <rect x="50" y="10" rx="4" ry="4" width="254" height="6" />
        <rect x="50" y="30" rx="5" ry="5" width="80%" height="30" />
    </ContentLoader>
)

export const SavedPostLoader = (props) => (
    <ContentLoader height={180} width={'100%'} backgroundColor={backgroundColor} foregroundColor={foregroundColor} {...props}>
        <rect x="0" y="0" rx="5" ry="5" width="100%" height="20" />
        <rect x="0" y="30" rx="5" ry="5" width="100%" height="100" />
        <rect x="0" y="140" rx="5" ry="5" width="60%" height="15" />
    </ContentLoader>
);

export const UserLoader = (props) => (
  <ContentLoader
    viewBox="0 0 150 180"
    width="100%"
    height="100%"
    preserveAspectRatio="xMidYMid meet"
    backgroundColor="#2E2E2E"
    foregroundColor="#3A3A3A"
    {...props}
  >
    <circle cx="75" cy="50" r="50" />
    <rect x="35" y="120" rx="5" ry="5" width="80" height="7" />
    <rect x="35" y="140" rx="5" ry="5" width="80" height="20" />
  </ContentLoader>
);



export const AlbumContentLoader = (props) => (
    <ContentLoader height={'100%'} width={'100%'} backgroundColor={backgroundColor} foregroundColor={foregroundColor} {...props}>
        <rect x="0" y="0" rx="5" ry="5" width="100%" height="100%" />
    </ContentLoader>
)


export const AlbumItemLoader = ({ height }) => (
    <ContentLoader width={'100%'} height={height ? 200 : 260} backgroundColor={height ? backgroundColor : foregroundColor} foregroundColor={height ? foregroundColor : backgroundColor}>
        {height ? 
             <>
                <rect x="0" y="0" rx="8" ry="8" width="100%" height={height} />
                <rect x="0" y="150" rx="5" ry="5" width="90%" height="10" />
                <rect x="0" y="170" rx="5" ry="5" width="50%" height="10" />
                <rect x="0" y="190" rx="5" ry="5" width="10%" height="10" />
            </>
            :
            <>
                <rect x="0" y="0" rx="8" ry="8" width="100%" height={"192"} />
                <rect x="0" y="210" rx="5" ry="5" width="90%" height="10" />
                <rect x="0" y="230" rx="5" ry="5" width="50%" height="10" />
                <rect x="0" y="250" rx="5" ry="5" width="10%" height="10" />
            </>
        }
    </ContentLoader>
)


export const EventItemLoader = ({isProfile}) => (
    <ContentLoader height={'100%'} width={'100%'} backgroundColor={isProfile ? backgroundColor : foregroundColor} foregroundColor={isProfile ? foregroundColor : backgroundColor}>
        <rect x="0" y="0" rx="8" ry="8" width="40%" height="100%" />
        <rect x="42%" y="110" rx="5" ry="5" width="20%" height="15" />
        <rect x="42%" y="135" rx="5" ry="5" width="35%" height="15" />
        <rect x="42%" y="160" rx="5" ry="5" width="50%" height="15" />
    </ContentLoader>
)


export const GroupItemLoader = (props) => (
    <ContentLoader height={'100%'} width={'100%'} backgroundColor={backgroundColor} foregroundColor={foregroundColor} {...props}>
        <rect x="0" y="0" rx="12" ry="12" width="128" height="112" />
        <rect x="140" y="80" rx="5" ry="5" width="80" height="8" />
        <rect x="140" y="100" rx="5" ry="5" width="140" height="8" />
        <rect x="0" y="124" rx="5" ry="5" width="100%" height="26" />
    </ContentLoader>
)

export const UserSearchLoader = ({ isProfile }) => (
    <ContentLoader height={60} width={'100%'} backgroundColor={isProfile ? backgroundColor : foregroundColor} foregroundColor={isProfile ? foregroundColor : backgroundColor}>
        <circle cx="35" cy="35" r="23" />
        <rect x="70" y="30" rx="4" ry="4" width="90" height="6" />
        <rect x="70" y="40" rx="4" ry="4" width="60" height="6" />
    </ContentLoader>
)

// export const UserSearchLoader = (props) => {
//     <ContentLoader height={'100%'} width={'100%'} backgroundColor={backgroundColor} foregroundColor={foregroundColor} {...props}>
//         <circle cx="50" cy="50" r="48" />
//         <rect x="75" y="10" rx="8" ry="8" width="50" height="8" />
//         <rect x="75" y="20" rx="8" ry="8" width="80" height="8" />
//     </ContentLoader>
// }


export const ReelSkeleton = () => (
    <div className="rounded-lg overflow-hidden w-full aspect-[3/4]">
        <ContentLoader
            speed={2}
            width="100%"
            height="100%"
            backgroundColor={foregroundColor}
            foregroundColor={backgroundColor}
        >
            <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%" />
        </ContentLoader>
    </div>
);

// const StorySkeleton = () => (
//     <div className="w-28 h-48 rounded-xl bg-[#353530] animate-pulse">
//       <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2">
//         <div className="w-10 h-10 rounded-full bg-gray-600"></div>
//       </div>
//     </div>
//   );


export const StoryCardSkeleton = () => (
    <div className="animate-pulse bg-[#1C1B19] rounded-[10px] overflow-hidden w-full flex flex-col shadow-black/25 shadow-xl pb-[8px]">
        <div className="w-full aspect-[92/100] bg-white/25" />
        <div className="p-1.5 flex flex-col gap-0.5">
            <div className="h-3 bg-white/25 rounded w-3/4 mb-1"></div>
            <div className="h-2 bg-white/25 rounded w-1/2 mb-1"></div>
            <div className="h-2 bg-white/25 rounded w-1/5"></div>
        </div>
    </div>
);